module.exports = __webpack_public_path__ + "static/media/bg_03.e2b75846.png";